<template>
  <div class="product-form__input-wrap">
    <div class="product-form__title">{{ label }}</div>
    <input
      class="product-form__input"
      :type="type"
      v-model="object[fieldName]"
      @change="$root.$emit('productIsChanged'), dataValidation()"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    object: {
      type: Object,
      required: false,
    },
  },
  methods: {
    dataValidation() {
      //check ean code
      if (this.fieldName == "ean13") {
        if (!/^\d+$/.test(this.object[this.fieldName])) {
          this.$root.$emit("noticesBox", {
            message: "Kod EAN-13 musi składać się z samych cyfr.",
          });
        }

        if (this.object[this.fieldName].length < 13) {
          this.$root.$emit("noticesBox", {
            message: "Wprowadzono za mało znaków w kodzie EAN-13.",
          });
        }

        if (this.object[this.fieldName].length > 13) {
          this.$root.$emit("noticesBox", {
            message: "Wprowadzono za dużo znaków w kodzie EAN-13.",
          });
        }
      }
    },
  },
};
</script>
